import { useMemo } from "react";
import { ClientProviderEnum } from "../../../../constants";
import { PageContextUtils } from "../../../../utils";
import { useKambiMenuItemsMobile } from "./Kambi/useKambiMenuItemsMobile";
import { useKambiNumberOfItemsMobile } from "./Kambi/useKambiNumberOfItemsMobile";
import { useSpectateMenuItemsMobile } from "./Spectate/useSpectateMenuItemsMobile";
import { useSpectateNumberOfItemsMobile } from "./Spectate/useSpectateNumberOfItemsMobile";

export const useMobileCategories = () => {
  const { name } = PageContextUtils.getClientProviderData();
  const useNumberOfItems = useMemo(
    () =>
      name === ClientProviderEnum.Kambi
        ? useKambiNumberOfItemsMobile
        : name === ClientProviderEnum.Spectate
          ? useSpectateNumberOfItemsMobile
          : null,
    [name]
  );

  useNumberOfItems();

  const useMenuItems = useMemo(
    () =>
      name === ClientProviderEnum.Kambi
        ? useKambiMenuItemsMobile
        : name === ClientProviderEnum.Spectate
          ? useSpectateMenuItemsMobile
          : null,
    [name]
  );

  return useMenuItems();
};
